<template>
  <div
    class="w-[90%] mx-auto md:w-[] pb-2"
  >
    <!-- Header -->
    <div class="flex flex-col items-start gap-2 w-full">
      <div class="flex items-center gap-2">
  <!-- <UIcon
    v-show="!isMobile"
    name="i-heroicons-arrow-left"
    class="w-6 h-6 text-[#0C5542] cursor-pointer"
    @click="toggleEditProfile"
/> -->
        <!-- <button 
          class="flex items-center justify-center w-6 h-8 rounded-full mt-2"
          v-if="isDesktop"
        >
          <UIcon name="i-heroicons-arrow-left" class="w-6 h-6 md:w-8 md:h-8 text-leftArrow" @click="goBack()"/>
        </button> -->
        <h1
          class="font-rubik font-semibold text-xl sm:text-2xl md:text-[28px] leading-tight text-[#111111]  mt-2"
        >
          {{ !isEditMode ? 'Create Your Account' : 'Edit Your Profile' }}
        </h1>
      </div>
      <p
        class="font-rubik font-normal text-sm sm:text-base text-[#626363] "
      >
        {{ !isEditMode 
          ? `Enter your details below to create your account on ${partnerName}.`
          : 'Edit your profile details below.' }}
      </p>
    </div>

    <!-- Profile Form -->
    <form @submit.prevent="onSubmit" class="flex flex-col items-center w-full gap-12 mt-4 md:mt-0 pb-32">
      <div class="flex flex-col items-center w-full gap-6">
      <!-- Profile Picture -->
      <div class="relative w-[90px] h-[90px] sm:w-[110px] sm:h-[110px]">
        <div class="w-full h-full bg-gray-300 rounded-full flex items-center justify-center mt-2">
          <!-- <UIcon name="i-heroicons-user" class="w-12 h-12 text-white" /> -->
           <img src="/v2/icons/Profile-Icon.png" />
        </div>
        <!-- <button
          type="button"
          class="absolute -bottom-2 -right-2 flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full shadow-md"
        >
          <UIcon name="i-heroicons-camera" class="w-5 h-5 text-[#0C5542]" />
        </button> -->
      </div>

      <!-- Input Fields -->
      <div class="flex flex-col items-start w-full gap-4">
        <!-- Full Name -->
        <div class="flex flex-col gap-2 w-full">
          <div class="flex gap-1">
          <label class="text-sm font-rubik text-[#525252]">First Name</label>
          <span class="text-sm text-[#D00B0B]">*</span>
          </div>
          <input
          :value="state.first_name"
          maxlength="20"
          inputmode="text"
          autocomplete="given-name"
          type="text"
          placeholder="Enter first name"
          @input="(e) => {
            const clean = e.target.value
              .replace(/[^a-zA-Z ]/g, '')
              .replace(/\s+/g, ' ')
              .replace(/^\s/, '')
              .split(' ').slice(0, 2).join(' ');
            e.target.value = clean;
            state.first_name = clean;
            validateField('first_name');
          }"

            :class="[
              'w-full px-3 py-3 border rounded-lg text-sm text-[#303030] focus:outline-none bg-white-200','font-rubik font-medium text-[12px] leading-[100%] tracking-[0%]',
              errors.first_name.length ? 'border-[#D00B0B]' : 'border-[#D5D5D5] focus:border-primary-400'
            ]"          />
          <p v-for="(err, i) in errors.first_name" :key="i" class="text-sm text-[#D00B0B] flex items-center gap-1">
            <img src="/v2/icons/ProfileError.png" class="w-4 h-4" />
            <span>{{ err }}</span>
          </p>

        </div>
         <div class="flex flex-col gap-2 w-full">
          <div class="flex gap-1">
          <label class="text-sm font-rubik text-[#525252]">Last Name</label>
          <span class="text-sm text-[#D00B0B]">*</span>
          </div>
          <input
          :value="state.last_name"
          maxlength="20"
          inputmode="text"
          autocomplete="family-name"
          type="text"
          placeholder="Enter last name"
          @input="(e) => {
            const clean = e.target.value.replace(/[^a-zA-Z]/g, '');
            e.target.value = clean;
            state.last_name = clean;
            validateField('last_name');
          }"
            :class="[
              'w-full px-3 py-3 border rounded-lg text-sm text-[#303030] focus:outline-none bg-white-200','font-rubik font-medium text-[12px] leading-[100%] tracking-[0%]',
              errors.last_name.length ? 'border-[#D00B0B]' : 'border-[#D5D5D5] focus:border-primary-400'
            ]"             />
          <p v-for="(err, i) in errors.last_name" :key="i" class="text-sm text-[#D00B0B] flex items-center gap-1">
            <img src="/v2/icons/ProfileError.png" class="w-4 h-4" />
            <span>{{ err }}</span>
          </p>
        </div>
        <!-- Mobile -->
        <div class="flex flex-col gap-2 w-full">
          <div class="flex gap-1">
          <label class="text-sm font-rubik text-[#525252]">Mobile Number</label>
          <span class="text-sm text-[#D00B0B]">*</span>
          </div>
          <input
            v-model="state.phone"
            type="tel"
            placeholder="Enter 10-digit mobile number"
            :class="[
              'w-full px-3 py-3 rounded-lg text-sm text-[#828282] bg-[#E9E9E9]','font-rubik font-medium text-[12px] leading-[100%] tracking-[0%]',
              errors.phone.length ? 'border-[#D00B0B]' : ''
            ]"
            disabled
          />
          <p v-for="(err, i) in errors.phone" :key="i" class="text-sm text-[#D00B0B] flex items-center gap-1">
            <img src="/v2/icons/ProfileError.png" class="w-4 h-4" />
            <span>{{ err }}</span>
          </p>
        </div>

        <!-- Email -->
        <div class="flex flex-col gap-2 w-full">
          <div class="flex gap-1">
          <label class="text-sm font-rubik text-[#525252]">Email ID</label>
          <span class="text-sm text-[#D00B0B]">*</span>
          </div>
          <input
          v-model="state.email"
          @input="validateField('email')"
          type="text"
          inputmode="email"
          autocomplete="email"
          placeholder="example@gmail.com"
            :class="[
              'w-full px-3 py-3 border rounded-lg text-sm text-[#303030] focus:outline-none bg-white-200','font-rubik font-medium text-[12px] leading-[100%] tracking-[0%]',
              errors.email.length ? 'border-[#D00B0B]' : 'border-[#D5D5D5] focus:border-primary-400'
            ]"          
          />
          <p v-for="(err, i) in errors.email" :key="i" class="text-sm text-[#D00B0B] flex items-center gap-1">
            <img src="/v2/icons/ProfileError.png" class="w-4 h-4" />
            <span>{{ err }}</span>
          </p>
        </div>

        <!-- DOB -->
        <div class="w-full space-y-1">
          <label class="text-sm font-rubik text-gray-600">Date of Birth</label>
          <div class="aesthetic-datepicker">
            <VueDatePicker
              v-model="dobDate"
              :ui="{ input: 'w-full text-sm rounded-lg border px-3 text-[#303030] focus:outline-none focus:border-primary-400 bg-white font-rubik font-medium text-[12px] leading-[100%]' }"              
              :formats="{ input: 'dd/MM/yyyy' }"
              :max-date="new Date()"
              :input-attrs="{ clearable: false }"
              @update:model-value="updateDob"
              :time-config="{ enableTimePicker: false }"
              auto-apply
              :transitions="transitions"
            >
              <template v-slot:input-icon>
                <span class="dp__icon dp__input_icon dp__input_icons">
                  <img src="/v2/icons/Calendar.png" class="w-4 h-4" v-if="runtimeConfig?.public?.partnerCode?.toLowerCase() === 'mall4all'"/>
                  <UIcon name="i-lucide-calendar-days" class="text-primary w-4 h-4" v-else />
                </span>
              </template>
            </VueDatePicker>
          </div>
        </div>
      </div>

      <!-- Gender -->
      <div class="flex flex-col gap-4 w-full">
        <h3 class="font-rubik font-semibold text-base sm:text-lg text-black">Select Gender</h3>
        <div class="flex flex-row flex-wrap gap-6 sm:gap-8">
          <label class="flex items-center gap-2">
            <input type="radio" v-model="state.gender" value="male" class="accent-primary" />
            <span class="text-sm sm:text-base text-[#111111]">Male</span>
          </label>

          <label class="flex items-center gap-2">
            <input type="radio" v-model="state.gender" value="female" class="accent-primary" />
            <span class="text-sm sm:text-base text-[#111111]">Female</span>
          </label>

          <label class="flex items-center gap-2">
            <input type="radio" v-model="state.gender" value="other" class="accent-primary" />
            <span class="text-sm sm:text-base text-[#111111]">Other</span>
          </label>
        </div>
        </div>
      </div>

      <!-- Submit -->
      <!-- <button
        type="submit"
        class="flex items-center justify-center w-full sm:w-[343px] h-10 rounded-lg bg-[#0C5542] text-white font-medium text-sm"
        :disabled="isLoading"
      >
        {{ !checkComplete ? 'SAVE' : 'UPDATE PROFILE' }}
      </button> -->
      <button
      type="submit"
      :class="[
        'flex items-center justify-center w-full hidden sm:flex sm:w-[343px] h-10 rounded-lg text-white font-medium text-sm',
        checkComplete ? 'bg-primary' : 'bg-[#B2B2B2] button-disabled cursor-not-allowed'
      ]"
      :disabled="isLoading || !checkComplete"
    >
      {{ !isEditMode ? 'SAVE' : 'UPDATE PROFILE' }}
      </button>
      <div class="fixed bottom-0 left-0 right-0 z-50 bg-white px-4 py-3 md:hidden shadow-[0_-2px_10px_rgba(0,0,0,0.08)]">
        <button
      type="submit"
      :class="[
        'flex items-center justify-center w-full sm:w-[343px] h-10 rounded-lg text-white font-medium text-sm',
        checkComplete ? 'bg-primary' : 'bg-[#B2B2B2] button-disabled cursor-not-allowed'
      ]"
      :disabled="isLoading || !checkComplete"
    >
      {{ !isEditMode ? 'SAVE' : 'UPDATE PROFILE' }}
      </button>

      </div>
    </form>
    <V2ProfileToast class="" :message="errorMessage" :visible="showError" />

  </div>
</template>


<script setup lang="ts">
import { reactive, ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { VueDatePicker } from '@vuepic/vue-datepicker';
import { parse } from 'date-fns';
import { GoogleAnalytics } from '~/google_analytics/events';
import { EventParameter } from '~/google_analytics/events.enum';
const { getPreviousRoute } = useNavigationHistory();
const { isMobile, isDesktop } = useDevice()
const router = useRouter();
const { gtag } = useGtag(); // Properly destructure gtag
const auth = useAuth();
const toast = useToast();
const route = useRoute();
const rawPath = route?.query?.redirect || route?.query?.path;
const isAuthenticated = auth && auth.access_token;
const userData = isAuthenticated
  ? {
      user_name: auth.user.first_name,
      user_phone: auth.user.phone,
      user_email: auth.user.email,
    }
  : { user_name: null, user_phone: null, user_email: null };
const state = reactive({
  first_name: auth.user.first_name || '',
  last_name: auth.user.last_name || '',
  phone: auth.user.phone || '',
  email: auth.user.email || '',
  dob: auth.user?.dob || '',
  gender: auth.user?.gender || '',
});
const isEditMode = ref(false)
const dobDate = ref(state.dob ? parse(state.dob, 'dd/MM/yyyy', new Date()) : null);
function updateDob(val: Date | null) {
  if (val) {
    const day = String(val.getDate()).padStart(2, '0');
    const month = String(val.getMonth() + 1).padStart(2, '0');
    const year = val.getFullYear();
    state.dob = `${day}/${month}/${year}`;
  } else {
    state.dob = '';
  }
}
const isLoading = ref(false);
const transitions = {
  open: "fade",
  close: "fade",
  next: "slide",
  previous: "slide",
};
const checkComplete = computed(() => {
  return state.email && state.last_name && state.first_name && state.phone;
});

// const isMobile = computed(() => window.innerWidth <= 768);

function goToMenu(query = {}) {
  router.push({path: '/account/profile',query});
}

function toggleEditProfile() {
  router.back();
}

const errorMessage = ref('')
const showError = ref(false)

const showToast = (msg: string) => {
  GoogleAnalytics.toast({
    [EventParameter.TOAST_MESSAGE]: msg,
  })
  errorMessage.value = msg
  showError.value = true
  setTimeout(() => (showError.value = false), 3000)
}
const errors = reactive({
  first_name: [],
  last_name: [],
  phone: [],
  email: [],
})

const toStr = (val: unknown) => String(val ?? '')
const validators = {
  required: (fieldLabel: string) => (val: unknown) => {
    const v = String(val ?? '').trim()
    return v ? '' : `Please enter your ${fieldLabel}`
  },
  maxLength : (len: number) => (val: unknown) => {
    const v = toStr(val).trim()
    return v.length <= len ? '' : `Maximum ${len} characters allowed`
  },
  minLength: (len: number) => (val: unknown) => {
    const v = toStr(val).trim()
    return v.length >= len ? '' : `Minimum ${len} characters required`
  },
  lettersOnly: (fieldLabel: string) => (val: unknown) => {
    const v = toStr(val).trim()
    return /^[A-Za-z ]+$/.test(v) ? '' : `Please enter a valid ${fieldLabel}`
  },

  email: (val: unknown) => {
    const v = toStr(val).trim()
    return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v)
      ? ''
      : 'Please enter a valid Email address'
  },

  phone: (val: unknown) => {
    const v = toStr(val).trim()
    return /^[6-9]\d{9}$/.test(v)
      ? ''
      : 'Please enter a valid 10-digit mobile number'
  },
}

const validationRules = {
  first_name: [
    validators.required('first name'),    
    validators.maxLength(20),
    validators.minLength(3),
    validators.lettersOnly('first name'),
  ],
  last_name: [
    validators.required('last name'),    
    validators.maxLength(20),
    validators.lettersOnly('last name'),
  ],
  phone: [
    validators.required('mobile number'),
    validators.phone,
  ],
  email: [
    validators.required('email id'),
    validators.email,
  ],
}
const validateForm = () => {
  Object.keys(validationRules).forEach(key => (errors[key] = []))

  let isValid = true

  for (const field in validationRules) {
    const value = state[field as keyof typeof state] as string

    for (const rule of validationRules[field as keyof typeof validationRules]) {
      const error = rule(value)
      if (error) {
        errors[field] = [error]
        isValid = false
        break // stop at first error per field
      }
    }
  }
  return isValid
}

const validateField = (field: keyof typeof validationRules) => {
  errors[field] = []

  const value = state[field as keyof typeof state] as string

  for (const rule of validationRules[field]) {
    const error = rule(value)
    if (error) {
      errors[field] = [error]
      break
    }
  }
}

async function onSubmit() {
  if (!validateForm()) {
    return
  }
  isLoading.value = true;
  try {
    const apiResult: any = await $apiServer('/account/profile', {
      method: 'post',
      headers: { Authorization: `Bearer ${auth.access_token}` },
      body: {
        first_name: (state.first_name ?? '').trim().replace(/\s+/g, ' '),
        last_name: (state.last_name ?? '').trim().replace(/\s+/g, ' '),
        email: state.email,
        dob: state.dob,
        gender: state.gender,
      },
    });

    if (apiResult.data.toLowerCase() === 'success') {
      if (!isEditMode.value) {
        localStorage.setItem('userExists', 'true')
        isEditMode.value = true
      }
      const getUser: any = await $apiServer('/account/profile', {
        headers: { Authorization: `Bearer ${auth.access_token}` },
      });
      auth.setAccessToken(auth.access_token);
      auth.setUser(getUser.data);
     if (!isMobile) {
      showToast(
      `Your profile has been updated`
      );
        setTimeout(() => {
          window.location.reload();
        }, 1000); 
      } else {
          goToMenu({ showToast: true });
      }

    }
    isLoading.value = false;
  } catch (err) {
    console.log(err);
    isLoading.value = false;
  }

  GoogleAnalytics.cta({
    [EventParameter.CTA_NAME]: !isEditMode ? 'save' : 'update_profile',
  })
}

const goBack = () => {
  // Try custom navigation history first
  const previousRoute = getPreviousRoute();
  if (previousRoute) {
    navigateTo(previousRoute);
    return;
  }
  // Fallback to resolvedPath or home
  const resolvedPath = Array.isArray(rawPath) ? rawPath[0] : rawPath;
  if (resolvedPath) {
    navigateTo(resolvedPath);
  } else {
    navigateTo('/');
  }
};
const runtimeConfig = useRuntimeConfig();
const partnerName = usePartnerDisplayName(runtimeConfig.public.partnerCode);

onMounted(() => {
  const userExists = localStorage.getItem('userExists')
  isEditMode.value = userExists === 'true'
})
</script>
<style>
  .aesthetic-datepicker {
  --dp-border-radius: 8px;
  --dp-input-padding: 12px 30px 12px 12px;
  --dp-font-family: 'Rubik', sans-serif;
  --dp-font-size: 0.75rem;
  --dp-input-icon-padding: 10px;
}
    @media (min-width: 768px) {
      .aesthetic-datepicker {
        --dp-font-size: 0.875rem;
      }
    }
  .dp__input_icon {
    width: 16px !important;
    height: 16px !important;
    right: 4px !important;
    left: auto !important;
  }
  .dp__active_date,
 .dp__active_date:hover {
    @apply bg-primary text-white rounded-full !important;
  }
  .dp__cell_inner:hover:not(.dp__active_date) {
    background-color: transparent !important;
    color: inherit !important;
    box-shadow: none !important;
    transform: none !important;
    backdrop-filter: none !important;
  }
  .dp__overlay_cell_active { 
    @apply bg-primary text-white rounded-full !important;
  }
  .dp__overlay_cell_active {
    background-color: #f97316 !important;
    color: #ffffff !important;
    border-radius: 9999px !important;
  }
  .dp__overlay_col:hover .dp__overlay_cell_pad:not(.dp__overlay_cell_active) {
    background-color: rgba(249, 115, 22, 0.15) !important;
    color: #9a3412 !important;
    backdrop-filter: blur(4px);
    border-radius: 9999px !important;
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(249, 115, 22, 0.25);
    transition: all 0.15s ease !important;
  }
  .fade-enter-active,
  .fade-leave-active { transition: opacity 0.2s ease; }
  .fade-enter-from,
  .fade-leave-to { opacity: 0; }
  
  .slide-enter-active,
  .slide-leave-active { transition: all 0.25s ease; }
  .slide-enter-from { transform: translateX(16px); opacity: 0; }
  .slide-leave-to { transform: translateX(-16px); opacity: 0; }
  </style>
  